import {ENDPOINT_URL} from 'constants/index';
import {apiErrorHandling} from 'utils/apiUtils';

import getFetchOptions from 'utils/getFetchOptions';

export default function unblockUser(userIds) {
	return fetch(
		`${ENDPOINT_URL}/unblockuser`,
		getFetchOptions({
			method: 'POST',
			body: JSON.stringify({
				ids: userIds,
			}),
		})
	)
		.then((response) => {
			if (!response.ok) {
				throw response;
			}
			return response.json();
		})
		.catch((err) => {
			return Promise.reject(apiErrorHandling(err));
		});
}
